import { render } from "./image-gallery-modal.vue?vue&type=template&id=345b1c6a&scoped=true&lang=pug"
import script from "./image-gallery-modal.vue?vue&type=script&lang=js"
export * from "./image-gallery-modal.vue?vue&type=script&lang=js"

import "./image-gallery-modal.vue?vue&type=style&index=0&id=345b1c6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345b1c6a"]])

export default __exports__